export default __webpack_public_path__ + "status-page-icon@2x.png";